import { SALES as p } from "./index.es451.js";
import u from "qs";
import { rankTypes as _, pluralizeEntityTypes as c } from "./index.es263.js";
const f = (t) => (e) => {
  const s = {
    type: "venues,complexes",
    enable_available_pois: !0,
    enable_closed_pois: !1,
    enable_custom_pois: !1,
    enable_nearby_activity_pois: !0,
    enable_not_allowed: !0,
    purchased_only: !1,
    show_pois_in_critical_area: !0,
    skip: 0,
    sort_by: e.sortBy,
    date_preset: e.datePresetKey,
    limit: e.limit,
    source: "advanced-mapping",
    choice_filters: "sub_categories,chain_ids"
  };
  e.ne && e.sw && (s.ne = e.ne, s.sw = e.sw), e.excludedCategories && (s.exclude_category = e.excludedCategories.map(
    (n) => encodeURIComponent(n)
  )), e.chain_ids && e.chain_ids.length > 0 && (s.chain_ids = e.chain_ids.join()), e.subCategories && e.subCategories.length > 0 && (s.sub_category = e.subCategories.join());
  const a = u.stringify(s, { arrayFormat: "repeat" }), i = [e.rankBy];
  e.includeSalesMetrics && i.push(...p);
  const r = {
    metrics: i,
    periods: {
      [e.datePresetKey]: {
        start: e.startDate,
        end: e.endDate
      }
    },
    rank_types: _,
    projection: e.projection
  };
  return e.poisToExclude && e.poisToExclude.length > 0 && (r.exclude_entities = e.poisToExclude), e.withinGeojson && (r.within_geojson = e.withinGeojson), t.post(`/2/guru/search/ranking?${a}`, r);
}, $ = (t) => (e) => {
  const s = {
    type: "venues,complexes",
    enable_available_pois: !0,
    enable_closed_pois: !1,
    enable_custom_pois: !1,
    enable_nearby_activity_pois: !0,
    enable_not_allowed: !0,
    purchased_only: !1,
    show_pois_in_critical_area: !0,
    skip: 0,
    limit: 1e3,
    source: "advanced-mapping",
    choice_filters: "chain_ids"
  };
  e.ne && e.sw && (s.ne = e.ne, s.sw = e.sw), e.chain_ids && e.chain_ids.length > 0 && (s.chain_ids = e.chain_ids.join());
  const a = u.stringify(s, { arrayFormat: "repeat" }), i = {
    projection: e.projection
  };
  return t.post(`/2/guru/search/ranking?${a}`, i);
}, h = (t) => ({
  entities: e,
  startDate: s,
  endDate: a,
  excludeShoppingCenters: i,
  excludeFlagged: r,
  projection: n
}) => {
  const o = u.stringify({
    start_date: s,
    end_date: a,
    exclude_shopping_centers: i,
    exclude_flagged: r
  }), d = {
    entities: e.map((g) => ({ entity_id: g.id, entity_type: g.type })),
    projection: n
  };
  return t.post(`/1/tenants?${o}`, d);
}, b = (t) => (e = {
  only_in_use: !0,
  version: "v2",
  only_available_categories: !0
}, s) => {
  const a = u.stringify(e);
  return t.get(
    `/2/guru/categories?${a}`
  );
}, v = (t) => () => t.get("/2/guru/user/permitted_plugins/"), w = (t) => () => t.get(
  "/2/guru/user/custom_settings/"
), I = (t) => () => t.get("/2/guru/user/permissions/"), D = (t) => () => t.get(
  "/2/guru/entities/chains_by_categories"
), k = (t) => (e, s) => {
  const a = { enable_closed_pois: !1, ...e }, i = u.stringify(a);
  return t.get(
    `/2/guru/search?${i}`
  );
}, T = (t) => () => t.get("/2/guru/user/config"), P = (t) => (e) => t.post("/2/guru/entities", {
  entity_ids: e
}), C = (t) => ({
  entities: e,
  rankBy: s,
  datePresetKey: a,
  startDate: i,
  endDate: r,
  includeSalesMetrics: n
}) => {
  const o = [s];
  return n && o.push(...p), t.post(
    "/1/get_entity_ranking2",
    {
      entities: e,
      metrics: o,
      periods: {
        [a]: {
          start: i,
          end: r
        }
      },
      rank_types: _,
      unallowed_entity: "skip",
      skip_uncached: !0
    }
  );
}, j = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i, nearbyActivityRadius: r, audience: n }) => {
  const o = u.stringify({
    start_date: a,
    end_date: i
  }), d = r ? {
    config: {
      ft_radius: r
    }
  } : n ? {
    where: {
      audience_sector: n
    }
  } : {};
  return t.post(
    // eslint-disable-next-line max-len
    `/2/guru/${c[s]}/${e}/overview/visits?${o}`,
    d
  );
}, x = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i, audience: r }) => {
  const n = u.stringify({
    start_date: a,
    end_date: i
  }), o = {
    where: {
      audience_sector: r
    }
  };
  return t.post(
    // eslint-disable-next-line max-len
    `/2/guru/${c[s]}/${e}/overview/visits/by_audience?${n}`,
    o
  );
}, S = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i, audience: r }) => {
  const n = u.stringify({
    collection: c[s],
    start_date: a,
    end_date: i
  }), o = r ? {
    where: {
      audience_sector: r
    }
  } : {};
  return t.post(
    `/2/guru/${c[s]}/${e}/overview/times?${n}`,
    o
  );
}, O = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i, audience: r }) => {
  const n = u.stringify({
    collection: c[s],
    start_date: a,
    end_date: i
  }), o = r ? {
    where: {
      audience_sector: r
    }
  } : {};
  return t.post(
    `/2/guru/${c[s]}/${e}/overview/visitors?${n}`,
    o
  );
}, E = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i, audience: r }) => {
  const n = u.stringify({
    collection: c[s],
    start_date: a,
    end_date: i
  }), o = r ? {
    where: {
      audience_sector: r
    }
  } : {};
  return t.post(
    `/2/guru/${c[s]}/${e}/loyalty/visit-frequency?${n}`,
    o
  );
}, R = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i }) => {
  const r = u.stringify({
    skip_availability: !1,
    start_date: a,
    end_date: i
  });
  return t.get(
    `/2/guru/${c[s]}/${e}/sales/metrics?${r}`
  );
}, V = (t) => ({ poiId: e, poiType: s, startDate: a, endDate: i, nearbyActivityRadius: r }) => {
  const n = u.stringify({
    start_date: a,
    end_date: i
  }), o = r ? {
    config: {
      ft_radius: r
    }
  } : {};
  return t.post(
    `/2/guru/${c[s]}/${e}/report-access?${n}`,
    o
  );
}, A = (t) => ({ type: e, address: s, category: a, sub_category: i, geojson: r, name: n, provider: o }) => t.post("/2/guru/custom-poi/v2/create", {
  name: n,
  type: e,
  address: {
    formatted_address: s.formatted_address,
    address: s.address,
    city: s.city,
    state: s.state,
    state_code: s.state_code,
    country: s.country,
    country_code: s.country_code,
    zip_code: s.zip_code
  },
  category: a,
  sub_category: i,
  geojson: r,
  provider: o
}), B = (t) => (e) => t.post("/2/guru/custom-poi/v2/create", e), U = (t) => (e, s) => t.post(`/2/guru/custom-poi/v2/complexes/${e}/update`, s), F = (t) => (e) => t.post("/2/guru/custom-poi/v2/create-slim", e), q = (t) => ({ id: e, type: s }) => t.get(
  `/2/guru/custom-poi/v2/${c[s]}/${e}/status`
), z = (t) => ({ id: e, type: s }) => t.get(
  `/2/guru/nearby-activity/${c[s]}/${e}?ft_radius=250`
), G = (t) => ({ type: e, poiId: s, queryParams: a }) => t.get(
  `/2/guru/${c[e]}/${s}?${u.stringify({
    ...a ?? {}
  })}`
), K = (t) => ({ tagId: e, startDate: s, endDate: a }) => {
  const i = u.stringify({
    start_date: s,
    end_date: a,
    // -1 is not a proper way to return all. big number given to offset default limit of 1000
    limit: 1e6
  });
  return t.get(`/2/guru/tags/${e}?${i}`);
}, M = (t) => ({ filterMode: e = "all_allowed", tagType: s = "tag", limit: a, skip: i }) => {
  const r = u.stringify({
    filter_mode: e,
    tag_type: s,
    limit: a,
    skip: i
  });
  return t.get(`/2/guru/tags?${r}`);
}, N = (t) => ({ tagId: e }) => t.get(`/2/guru/tags/${e}/info/`), H = (t) => ({ tagId: e }) => t.get(`/2/guru/tags/${e}/list`), L = (t) => ({ name: e, entities: s, slim: a = !0, access: i = "restricted" }) => t.post("/2/guru/tags/create", {
  tag_type: "tag",
  name: e,
  entities: s,
  slim: a,
  access: i
}), J = (t) => ({ tagId: e, name: s, entities: a, access: i, slim: r }) => {
  const n = {
    ...s && { name: s },
    ...a && { entities: a },
    ...i && { access: i },
    ...(r || r === !1) && { slim: r }
  };
  return t.post(`/2/guru/tags/${e}/update`, n);
}, Q = (t) => ({ tagId: e, startDate: s, endDate: a, limit: i, skip: r }) => {
  const n = u.stringify({
    start_date: s,
    end_date: a,
    compared_start_date: s,
    compared_end_date: a,
    remove_lists_from_response: !0,
    ...i ? { skip: r, limit: i } : {}
  });
  return t.get(`/1/tags/${e}/member-metrics?v2=t&${n}`);
}, W = (t) => ({ entity_id: e, entity_type: s, ...a }) => {
  const i = u.stringify({
    ...a
  });
  return t.post(
    `/2/guru/${c[s]}/${e}/customer/heatmap?${i}`,
    {}
  );
}, X = (t) => (e, s, a = {
  id: !0,
  geolocation: !0,
  type: !0
}) => {
  const i = u.stringify(s), r = { projection: a };
  return t.post(
    `/1/chains/${e}/members_info?${i}`,
    r
  );
}, Y = (t) => ({ printId: e, jobIds: s }) => t.post(
  "/2/guru/export_print/job_status",
  {
    print_id: e,
    job_ids: s
  }
), Z = (t) => ({ params: e, widgets: s }) => t.post("/2/guru/export_print/create", {
  shared_params: e,
  widgets: s
}), ee = (t) => (e) => t.post("/2/guru/splunk-bulk", e);
export {
  B as createCustomPOI,
  A as createPOIResponse,
  Z as createPrint,
  F as createSlimCustomPOI,
  L as createTag,
  b as getCategories,
  $ as getChainVenueRankingPOI,
  X as getChainVenues,
  D as getChainsByCategories,
  h as getComplexTenants,
  q as getCustomPOIStatus,
  S as getDwellTime,
  C as getEntitiesRankingV2,
  P as getEntitiesV2,
  W as getGeoTradeAreaHeatmap,
  f as getNearbyRankingPOI,
  z as getNearbyReportStatus,
  G as getPOIData,
  V as getPOIReportAccess,
  j as getPOIVisits,
  x as getPOIVisitsAudience,
  Q as getPortfolioTagEntities,
  Y as getPrintStatus,
  R as getSales,
  N as getTag,
  H as getTagEntities,
  K as getTagVisits,
  M as getTags,
  T as getUserConfig,
  w as getUserCustomSettings,
  I as getUserPermissions,
  v as getUserPermittedPlugins,
  E as getVisitFrequency,
  O as getVisitors,
  k as searchEntities,
  ee as sendSplunkBulk,
  U as updateCustomPOI,
  J as updateTag
};
//# sourceMappingURL=index.es492.js.map
